/*
 * Copyright (C) 2023 DV Bern AG, Switzerland
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/>.
 */

export enum TSDemoFeature {
    ALLE_MUTATIONSMELDUNGEN_VERFUEGEN = 'ALLE_MUTATIONSMELDUNGEN_VERFUEGEN',
    KIBON_2754 = 'KIBON_2754',
    ZAHLUNGSSTATUS = 'ZAHLUNGSSTATUS',
    ZAHLUNGEN_STATISTIK = 'ZAHLUNGEN_STATISTIK',
    BEMERKUNGEN_FALLUEBERGREIFEND = 'BEMERKUNGEN_FALLUEBERGREIFEND',
    MEHRERE_FACHSTELLEN = 'MEHRERE_FACHSTELLEN',
    FACHSTELLEN_UEBERGANGSLOESUNG = 'FACHSTELLEN_UEBERGANGSLOESUNG',
    KIND_TERMINIEREN = 'KIND_TERMINIEREN',
    INSTITUTIONSSCHLIESSUNG_MUTATIONSMELDUNG = 'INSTITUTIONSSCHLIESSUNG_MUTATIONSMELDUNG'
}
